import React, { useContext, useState, useEffect } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import mfaApi from "../../api/mfaApi";
import AuthContext from "../../store/authContext";
import swal from "sweetalert";
import Main from "../../layout/Main";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Import skeleton styles

const Dashboard = () => {
  const authCtx = useContext(AuthContext);
  const [t_available, setT_available] = useState(0.0);
  const [totalearning, setTotalearning] = useState(0.0);
  const [total, setTotal] = useState(0.0);
  const [todaysenquiry, setTodaysenquiry] = useState(0.0);
  const [isLoading, setIsLoading] = useState(true); // Loading state

  const getEnquiryform = async () => {
    setIsLoading(true);
    try {
      const response = await mfaApi.get(`/administrator/enrolleduserdetails`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authCtx.token}`,
        },
      });

      if (response.status === 200) {
        const universityList = response.data.getAllEnrolledUser;
        setTotal(response.data.getAllEnrolledUser.length);

        // ✅ Safely sum all 'price' values
        const total = universityList.reduce(
          (sum, uni) => sum + (Number(uni.price) || 0),
          0
        );

        setTotalearning(total);
        // Get today's date string in YYYY-MM-DD format
        const today = new Date().toISOString().split("T")[0];

        // Filter entries where createdAt is today
        const todaysEntries = universityList.filter((item) => {
          const createdDate = new Date(item.createdAt)
            .toISOString()
            .split("T")[0];
          return createdDate === today;
        });
        setTodaysenquiry(todaysEntries.length);
        console.log("Total created today:", todaysEntries.length);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      // alert(error.response?.data?.message);
    }
  };

  const getEnquiry = async () => {
    try {
      const response = await mfaApi.get(`/administrator/usersdeatil`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authCtx.token}`,
        },
      });
      if (response.status === 200) {
        console.log(response.data);
        setT_available(response.data.users.length);
      }
    } catch (error) {
      console.log(error);

      // alert(error.response.data.message);
    }
  };

  useEffect(() => {
    getEnquiryform();
    getEnquiry();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Prepare data for the Bar chart
  const barChartData = {
    labels: ["Today's Enrollment", "Total Enrollment"],
    datasets: [
      {
        label: "Dashboard Graph Overview",
        data: [todaysenquiry, total],
        backgroundColor: ["#fdba74", "#93c5fd"], // orange-300, blue-300
        borderColor: ["#fb923c", "#60a5fa"], // orange-400, blue-400
        borderWidth: 1,
      },
    ],
  };

  const barChartOptions = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  // Prepare data for the Doughnut chart
  const doughnutChartData = {
    labels: ["Total Enrollment", "Today's Enrollment", "Total Students"],
    datasets: [
      {
        label: "Overview Graph",
        data: [total, todaysenquiry, t_available],
        backgroundColor: ["#93c5fd", "#fdba74", "#6ee7b7"], // blue-300, orange-300, emerald-300
        hoverBackgroundColor: ["#60a5fa", "#fb923c", "#34d399"], // blue-400, orange-400, emerald-400
      },
    ],
  };

  const doughnutChartOptions = {
    cutout: "60%", // Adjust the center cutout to make it more like a ring
  };

  return (
    <Main>
      <div className="flex flex-col w-full md:space-y-2 flex-shrink-0 overflow-scroll scroll-smooth scroll-m-0 bg-gray-50">
        <div className="w-full overflow-hidden">
          <h1 className="flex justify-center text-2xl font-normal text-gray-800 dark:text-white rounded-md">
            Dashboard
          </h1>

          {/* Grid layout for total, paid, refund, and available amounts */}
          <div className="grid grid-cols-2 gap-4 my-1 md:grid-cols-4 lg:grid-cols-4">
            {isLoading ? (
              // Render skeletons while loading
              <>
                <Skeleton height={120} className="rounded-lg" />
                <Skeleton height={120} className="rounded-lg" />
                <Skeleton height={120} className="rounded-lg" />
                <Skeleton height={120} className="rounded-lg" />
              </>
            ) : (
              // Render actual content once loaded
              <>
                <div className="relative h-32 w-full px-4 py-1 rounded-lg shadow-md bg-orange-100 border border-orange-300">
                  <p className="text-sm font-medium text-orange-800 border-b border-orange-300 w-max">
                    Today's Enrollment
                  </p>
                  <div className="flex items-end my-6 space-x-2">
                    <p className="text-3xl font-semibold text-orange-800">
                      {todaysenquiry || "0"}
                    </p>
                  </div>
                </div>
                <div className="relative h-32 w-full px-4 py-1 rounded-lg shadow-md bg-blue-100 border border-blue-300">
                  <p className="text-sm font-medium text-blue-800 border-b border-blue-300 w-max">
                    Total Enrollment
                  </p>
                  <div className="flex items-end my-6 space-x-2">
                    <p className="text-3xl font-semibold text-blue-800">
                      {total || "0"}
                    </p>
                  </div>
                </div>

                <div className="relative h-32 w-full px-4 py-1 rounded-lg shadow-md bg-emerald-100 border border-emerald-300">
                  <p className="text-sm font-medium text-emerald-800 border-b border-emerald-300 w-max">
                    Total Students
                  </p>
                  <div className="flex items-end my-6 space-x-2">
                    <p className="text-3xl font-semibold text-emerald-800">
                      {t_available || "0"}
                    </p>
                  </div>
                </div>
                <div className="relative h-32 w-full px-4 py-1 rounded-lg shadow-md bg-amber-100 border border-amber-300">
                  <p className="text-sm font-medium text-amber-800 border-b border-amber-300 w-max">
                    Total Earning
                  </p>
                  <div className="flex items-end my-6 space-x-2">
                    <p className="text-3xl font-semibold text-amber-800">
                      {totalearning || "0"}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Bar Chart representing the data */}
          <div className="flex flex-col md:flex-row justify-evenly">
            {/* Bar Chart */}
            <div className="w-full md:w-1/2 mt-8">
              <h2 className="text-xl text-center font-medium text-gray-800 dark:text-white">
                Enrollment Graph
              </h2>
              {isLoading ? (
                <Skeleton height={300} />
              ) : (
                <Bar data={barChartData} options={barChartOptions} />
              )}
            </div>

            {/* Doughnut Chart */}
            <div className="w-full md:w-1/3 mt-8">
              <h2 className="text-xl text-center font-medium text-gray-800 dark:text-white">
                Overview Graph
              </h2>
              {isLoading ? (
                <Skeleton height={300} />
              ) : (
                <Doughnut
                  data={doughnutChartData}
                  options={doughnutChartOptions}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Main>
  );
};

export default Dashboard;
